import { QuoteListItem } from '../../components/QuoteListItem'

export const QuoteStuckInPreparingSignatureRequestStatusListItem = (props: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => (
  <QuoteListItem {...props} description="Stuck preparing signature requests" />
)
